var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03101 3.5625C3.77212 3.5625 3.56226 3.77237 3.56226 4.03125V16.9688C3.56226 17.2276 3.77212 17.4375 4.03101 17.4375H16.9685C17.2274 17.4375 17.4373 17.2276 17.4373 16.9688V14.3961C17.4373 14.0854 17.6891 13.8336 17.9998 13.8336C18.3104 13.8336 18.5623 14.0854 18.5623 14.3961V16.9688C18.5623 17.849 17.8487 18.5625 16.9685 18.5625H4.03101C3.1508 18.5625 2.43726 17.849 2.43726 16.9688V4.03125C2.43726 3.15105 3.1508 2.4375 4.03101 2.4375H6.60365C6.91431 2.4375 7.16615 2.68934 7.16615 3C7.16615 3.31066 6.91431 3.5625 6.60365 3.5625H4.03101Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8125 3.19482C10.8125 2.88416 11.0643 2.63232 11.375 2.63232H17.2879C17.8834 2.63232 18.3661 3.11502 18.3661 3.71045V9.83768C18.3661 10.1483 18.1142 10.4002 17.8036 10.4002C17.4929 10.4002 17.2411 10.1483 17.2411 9.83768V3.75732H11.375C11.0643 3.75732 10.8125 3.50548 10.8125 3.19482Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6654 3.33271C17.885 3.55238 17.885 3.90854 17.6654 4.12821L11.5787 10.2151C11.359 10.4348 11.0028 10.4348 10.7832 10.2151C10.5635 9.99546 10.5635 9.6393 10.7832 9.41963L16.8699 3.33273C17.0895 3.11305 17.4457 3.11305 17.6654 3.33271Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1e56c02f803c64ab0b502ca85f3342bf.svg";
export { ForwardRef as ReactComponent };